import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux';
import { setShowMisconfiguredDialog } from '../../../state/actions/run-as-user';
import MisconfiguredMessage from './view';

const mapDispatchToProps = (dispatch: Dispatch) => ({
	onFix: () => dispatch(setShowMisconfiguredDialog(true)),
});

export default connect(() => ({}), mapDispatchToProps)(MisconfiguredMessage);
